/**
 * Borradores que SOBREVIVEN al cambio de tab (pedido muy repetido del equipo: escribes una nota
 * en "Overview", vas a "Files" a ver el nombre de un archivo y al volver la nota ya no está,
 * porque el tab se desmonta y el editor pierde su estado). Se guardan por `draftKey` en
 * sessionStorage → viven mientras la pestaña del navegador esté abierta y NO ensucian el server.
 * Al enviar el mensaje, el composer llama clearDraft() y se borra.
 */
const PREFIX = 'ppag.draft.';
/** Un borrador vive 14 días: más que eso es basura vieja, no una nota a medio escribir. */
const VIDA_MS = 14 * 86400000;

/**
 * 2026-10-20 (dueño: "every time I go to a different tab se me borra mi nota… que se me quede la nota
 * ahí hasta que lo termine"): el borrador pasa de sessionStorage a LOCALSTORAGE. sessionStorage es por
 * pestaña del navegador y muere con ella: abrir el claim en otra pestaña, recargar, o que la PWA se
 * reinicie, dejaba el editor vacío. localStorage sobrevive a todo eso; se guarda con fecha y se vence
 * solo. Lo guardado antes en sessionStorage se lee una vez más como respaldo.
 */
const store = (): Storage | null => {
  try { return typeof localStorage !== 'undefined' ? localStorage : null; } catch { return null; }
};

export function getDraft(key: string): string {
  if (!key) return '';
  try {
    const raw = store()?.getItem(PREFIX + key);
    if (raw) {
      const d = JSON.parse(raw) as { html?: string; at?: number };
      if (d && typeof d.html === 'string' && (!d.at || Date.now() - d.at < VIDA_MS)) return d.html;
    }
    if (typeof sessionStorage !== 'undefined') return sessionStorage.getItem(PREFIX + key) ?? '';
  } catch { /* privado / cuota */ }
  return '';
}

export function setDraft(key: string, html: string): void {
  if (!key) return;
  try {
    // Vacío (o solo un <br>/espacios que deja contentEditable) → se borra, no se guarda basura.
    const empty = !html || !html.replace(/<br\s*\/?>/gi, '').replace(/&nbsp;/gi, '').replace(/<[^>]*>/g, '').trim();
    if (empty) { clearDraft(key); return; }
    store()?.setItem(PREFIX + key, JSON.stringify({ html, at: Date.now() }));
  } catch { /* cuota llena / modo privado: el borrador no persiste, no es crítico */ }
}

export function clearDraft(key: string): void {
  if (!key) return;
  try { store()?.removeItem(PREFIX + key); } catch { /* */ }
  try { if (typeof sessionStorage !== 'undefined') sessionStorage.removeItem(PREFIX + key); } catch { /* */ }
}
